import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, makeObservable } from 'mobx';
import AuthenticationStore from '../../stores/Authentication';
import Modal from 'react-modal';
import LoginForm from '../Forms/Login';
import RegisterForm from '../Forms/Register';
import Translate from '../Translate/Translate';
import LocalizedLink from '../LocalizedLink';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { UserCircleIcon } from '@heroicons/react/24/outline';

interface Props {
  authentication?: AuthenticationStore;
  buttonText?: boolean;
  closeMobileMenu?: () => void;
}

@inject('authentication')
@observer
class ProfileButton extends React.Component<Props> {
  @observable modalOpen = false;
  constructor(props: Props) {
    super(props);
    makeObservable(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  @action toggleModal() {
    this.modalOpen = !this.modalOpen;
  }

  profileButton() {
    const { authentication, closeMobileMenu } = this.props;

    let button = (
      <button
        className="flex flex-col justify-center items-center border rounded-sm text-center cursor-pointer p-4 lg:p-0 border-solid border-rgrey-light w-full lg:h-10 lg:w-10 hover:bg-rgrey-light"
        onClick={this.toggleModal}
        aria-label="Logi sisse"
        title="Logi sisse"
      >
        <UserCircleIcon className="h-7 w-7" />
        <p className="lg:hidden uppercase pt-3 lg:pt-0 lg:pr-4 font-axi-bold text-center lg:whitespace-nowrap">
          <Translate component="login" keyword="login-button" />
        </p>
      </button>
    );

    if (authentication.initialized && authentication.loggedIn) {
      button = (
        <LocalizedLink
          to="/toolaud"
          onClick={closeMobileMenu}
          className="flex flex-col justify-center items-center rounded-sm text-center cursor-pointer p-4 lg:p-0 text-white border border-solid border-black bg-black fill-white w-full lg:h-10 lg:w-10"
          ariaLabel="Minu konto"
          title="Minu konto"
        >
          <UserCircleIcon className="h-7 w-7" />
          <p className="lg:hidden uppercase pt-3 lg:pt-0 lg:pr-4 font-axi-bold text-center lg:whitespace-nowrap">
            <Translate component="mobile-menu" keyword="login" />
          </p>
        </LocalizedLink>
      );
    }

    return button;
  }

  render() {
    return (
      <div className="flex">
        {this.profileButton()}
        <Modal
          isOpen={this.modalOpen}
          className={
            'absolute bg-white max-w-xl overflow-scroll w-full p-14 right-0 inset-y-0 focus:outline-none'
          }
          overlayClassName={'fixed bg-black/60 z-[99999] inset-0'}
          onRequestClose={this.toggleModal}
          onAfterOpen={() => {
            document.body.style.overflow = 'hidden';
          }}
          onAfterClose={() => {
            document.body.removeAttribute('style');
          }}
        >
          <div className="items-center flex text-base justify-end mb-5 font-axi-bold">
            {/* <h5 className="text-sm font-axi-bold">
              <Translate component="dashboard" keyword="konto" />
            </h5> */}
            <div
              className="flex items-center justify-center"
              onClick={this.toggleModal}
            >
              <h5 className="text-sm font-axi-bold">
                <Translate component="modal-content" keyword="close" />
              </h5>
              <button
                type="button"
                aria-label="Sulge modal"
                className="ml-5 h-10 w-10 rounded-sm bg-black p-2 text-white"
              >
                <XMarkIcon className="h-6 w-6 stroke-3" aria-hidden="true" />
              </button>
            </div>
          </div>
          <div className="user-drawer">
            <LoginForm toggle={this.toggleModal} />
            <RegisterForm toggle={this.toggleModal} />
          </div>
        </Modal>
      </div>
    );
  }
}

export default ProfileButton;
